import React from 'react';
import { useTranslation } from 'react-i18next';

import { DateInput } from './DateInput';
import { ConditionTypeSelector } from './ConditionTypeSelector';

import style from './ConditionsSelector.module.css';

const ConditionItem = ({
  conditionDate = null,
  conditionsCatalog = [],
  conditionSelected = null,
  loading = false,
  maxDate = '',
  minDate = '',
  onConditionDateSelected = () => {},
  onConditionTypeSelected = () => {},
  onRemoveCondition = () => {},
  removable = false,
}) => {
  const { t } = useTranslation('fileClaimbot');

  const onSelectedValidDate = ({ date }) => {
    onConditionDateSelected(date);
  };

  return (
    <div className={style.conditionItemContainer}>
      <ConditionTypeSelector
        conditionsCatalog={conditionsCatalog}
        conditionSelected={conditionSelected}
        loading={loading}
        onConditionTypeSelected={onConditionTypeSelected}
        onRemoveCondition={onRemoveCondition}
        removable={removable}
      />

      <DateInput
        maxDate={maxDate}
        minDate={minDate}
        onSelectedValidDate={onSelectedValidDate}
        selectedDate={conditionDate}
        title={t('conditions.datePicker.title')}
        useMarginLeft={false}
      />
    </div>
  );
};

export { ConditionItem };
